
import React from 'react'
import ReactDOM from 'react-dom'

import Checkout from './components/Checkout'

import 'react-select/scss/default.scss'
import './styles/index.scss'
import './favicon.png'


ReactDOM.render(<Checkout/>, document.getElementById('root'));


// WEBPACK FOOTER //
// ./client/app.js